import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task01 } from "../../../../../task/course-01/lesson-18/task-01";

const task: Slide = {
  titleHtml:
    "Consider the following geometry. Which expression of the basis is compatible with the boundary<br>conditions and which are the correct constraints on wave numbers imposed by boundary conditions?",
  description: "Select the correct answer.",
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 1,
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/01/18/task/task-1.svg`,
                },
              },
              styles: {
                padding: "5%",
              },
            },
          },
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
